import { render, staticRenderFns } from "./illegalBuilding-add.vue?vue&type=template&id=0a6f233f&scoped=true&"
import script from "./illegalBuilding-add.vue?vue&type=script&lang=js&"
export * from "./illegalBuilding-add.vue?vue&type=script&lang=js&"
import style0 from "./illegalBuilding-add.vue?vue&type=style&index=0&id=0a6f233f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6f233f",
  null
  
)

export default component.exports